<template>
  <div class="custom-title">
    <h1 class="title" :class="headerClass" :style="textStyle()">{{ text }}</h1>
    <span class="underline" :style="stripeStyle()"></span>
  </div>
</template>

<style lang="scss" scoped>
  .custom-title {
    margin: 3em 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .introduction-title {
    padding: 0;
    margin-top: 0;
  }

  .contact-title {
    margin-top: 5rem;
  }

  .title {
    font-size: 2rem;
    font-family: 'OpenSans-Bold', sans-serif;
    font-weight: 700;
    margin-bottom: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .underline {
    width: 60px;
    height: 4px;
    margin-bottom: 1rem;
  }

  h1.title {
    margin: 0 0 0.5rem;
    padding: 0;
  }
</style>

<script>
export default {
  props: {
    headerClass: {
      required: true
    },
    text: {
      required: true
    },
    textColour: {
      required: true
    },
    stripeColour: {
      required: true
    }
  },
  methods: {
    stripeStyle () {
      return `background-color: ${this.stripeColour}`
    },
    textStyle () {
      return `color: ${this.textColour}`
    }
  }
}
</script>
